export default {
    methods: {
        parseDate(date) {
            let year = date.substring(0, 4);
            let month = date.substring(5,7);
            let day = date.substring(8, 10);

            let monthName = "";

            // Converts month into their respective names
            switch(month) {
              case "01":
                monthName = "Jan";
                break;
              case "02":
                monthName = "Feb";
                break;
              case "03":
                monthName = "Mar";
                break;
              case "04":
                monthName = "Apr";
                break;
              case "05":
                monthName = "May";
                break;
              case "06":
                monthName = "Jun";
                break;
              case "07":
                monthName = "Jul";
                break;
              case "08":
                monthName = "Aug";
                break;
              case "09":
                monthName = "Sep";
                break;
              case "10":
                monthName = "Oct";
                break;
              case "11":
                monthName = "Nov";
                break;
              case "12":
                monthName = "Dec";
                break;
              default:
                monthName = "";
            }

            // Returns only one digit if the first digit of the day starts with "0"
            day.substring(0, 1) === "0" ? day = day.substring(1, 2) : day = day.substring(0, 2);

            return day + " " + monthName + " " + year;
        }
    }
};